import React, { useState, useEffect } from "react";
import { PREDEFINED_OPTIONS } from "./chat.types";
import { ChevronRight, Loader2 } from "lucide-react";
import { useServerFn } from "@tanstack/react-start";
import { getAIChatSettings } from "@/lib/admin/ai-chat.functions";

interface ChatWelcomeProps {
  onSelectOption: (id: string) => void;
}

export function ChatWelcome({ onSelectOption }: ChatWelcomeProps) {
  const [welcomeMessage, setWelcomeMessage] = useState("Our Healthy Kitchen team is here to help you choose meals that fit your needs. Select an option below to start:");
  const fetchSettings = useServerFn(getAIChatSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings()
      .then(settings => {
        if (settings?.welcome_message) {
          setWelcomeMessage(settings.welcome_message);
        }
      })
      .catch(err => console.error("[ChatWelcome] Failed to fetch settings:", err))
      .finally(() => setLoading(false));
  }, [fetchSettings]);

  return (
    <div className="flex flex-col p-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="mb-6">
        <h2 className="text-xl font-display font-medium text-foreground">
          Need help choosing your perfect meal?
        </h2>
        {loading ? (
          <div className="flex items-center gap-2 text-muted-foreground py-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span className="text-sm">Connecting...</span>
          </div>
        ) : (
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
            {welcomeMessage}
          </p>
        )}
      </div>

      <div className="grid gap-2">
        {PREDEFINED_OPTIONS.map((option) => (
          <button
            key={option.id}
            onClick={() => onSelectOption(option.id)}
            className="flex items-center justify-between rounded-xl border border-border bg-card p-3.5 text-left text-sm font-medium transition-all hover:border-primary/50 hover:bg-primary/5 hover:translate-x-1 active:scale-[0.98]"
          >
            <span>{option.label}</span>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </button>
        ))}
      </div>
      
      <div className="mt-8 rounded-2xl bg-secondary/50 p-4 border border-secondary">
        <h4 className="text-xs font-bold uppercase tracking-wider text-primary mb-1">Office Hours</h4>
        <p className="text-xs text-muted-foreground">Mon - Sat: 9 AM to 7 PM IST</p>
      </div>
    </div>
  );
}